import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withCartDonationItem } from "./withCartDonationItem"
import ImageCTA from "../../Image/ImageCTA"
import { Icon } from "../../Icon/Icon"
import { StyledH3 } from "../../Styled/Text"

const Wrapper = styled.div`
  ${tw`w-full flex flex-row justify-between border border-dark rounded-1 mb-3-2 bg-lightest`}
  ${({ display }) => (display ? tw`flex` : tw`hidden`)}
`
const ContentSection = tw.div`relative flex justify-start items-center w-full h-full p-2`
const RemoveIcon = styled.span`
  ${tw`absolute z-20 top-0 left-none right-0 md:left-0 md:right-none m-1 md:-m-1 w-2 h-2 rounded-full bg-lightest md:bg-dark flex items-center justify-center text-10 text-dark font-body cursor-pointer`}
  @media screen and (min-width: 48rem) {
    & {
      svg,
      img {
        -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
        filter: invert(100%);
      }
    }
  }
`
const ImageWrapper = tw.div`relative min-w-5 h-full`
const ContentWrapper = tw.div`flex-col px-1-6 md:px-3-2 md:max-w-33`
const Title = tw(StyledH3)``
const Content = tw.div``

export const CartDonationItem = withCartDonationItem(
  ({ display, donationTitle, donationContent, donationImage, handleRemove }): JSX.Element => (
    <Wrapper display={display ? `true` : undefined}>
      <ContentSection>
        <RemoveIcon onClick={handleRemove}>
          <Icon name={`cross`} size={10} ratio={`1/1`} />
        </RemoveIcon>
        <ImageWrapper>
          <ImageCTA image={donationImage} />
        </ImageWrapper>
        <ContentWrapper>
          <Title>{donationTitle}</Title>
          <Content>{donationContent}</Content>
        </ContentWrapper>
      </ContentSection>
    </Wrapper>
  )
)
